import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import {
    IBannerCreateRequest, BannerCreateSuccess, IBannerDeleteRequest, IBannerDeleteSucess, IBannnerGetSuccess,
    IBanner, IBannnerGetRequest, IBannerUpdateRequest, IBannerUpdateSuccess, IBannerUpdate, IBannerCreate
} from '../intefaces/IBanner'
import { IError } from '../intefaces'

export interface BannerState {
    isCreating: boolean | null,
    isUpdating: boolean | null,
    loading: boolean,
    bannerList: IBanner[],
    bannerOriginList: IBanner[],
    isShowEdit: boolean,
    isShowAdd: boolean,
    fileCrop: string,
    bannerCreate: IBannerCreate
    bannerUpdate: IBannerUpdate
}

const bannerCreate: IBannerCreate = {
    label: '',
    banner: '',
    gradeId: [],
    type: '',
    link: '',
    screen: ''
}

const bannerUpdate: IBannerUpdate = {
    id: '',
    label: '',
    isShow: false,
    gradeId: [],
    type: '',
    link: '',
    screen: ''
}

const initialState: BannerState = {
    isCreating: null,
    isUpdating: null,
    loading: false,
    bannerList: [],
    bannerOriginList: [],
    isShowEdit: false,
    isShowAdd: false,
    fileCrop: '',
    bannerCreate: bannerCreate,
    bannerUpdate: bannerUpdate
}

export const bannerSlice = createSlice({
    name: 'banner',
    initialState,
    reducers: {
        getBanners: (state, action: PayloadAction<IBannnerGetRequest>) => {
            state.loading = true;
        },
        getBannersSuccess: (state, action: PayloadAction<IBannnerGetSuccess>) => {
            state.loading = false;
            state.bannerList = action.payload.data;
            state.bannerOriginList = action.payload.data;
        },
        getBannersFailure: (state, action: PayloadAction<IError>) => {
            state.loading = false;
            state.bannerList = [];
        },
        createBanner: (state, action: PayloadAction<IBannerCreateRequest>) => {
            state.isCreating = true;
        },
        createBannerSuccess: (state, action: PayloadAction<BannerCreateSuccess>) => {
            state.isCreating = false;
            state.bannerList = [...state.bannerList, action.payload.data];
            state.bannerOriginList = state.bannerList;
        },
        createBannerFailure: (state, action: PayloadAction<IError>) => {
            state.isCreating = false;
        },
        updateBanner: (state, action: PayloadAction<IBannerUpdateRequest>) => {
            state.isUpdating = true;
        },
        updateBannerSuccess: (state, action: PayloadAction<IBannerUpdateSuccess>) => {
            state.isUpdating = false;
            state.bannerList = getBannerUpdate(state.bannerList, action.payload.data)
            state.bannerOriginList = state.bannerList;
        },
        updateBannerFailure: (state, action: PayloadAction<IError>) => {
            state.isUpdating = false;
        },
        deleteBanner: (state, action: PayloadAction<IBannerDeleteRequest>) => {
            state.loading = true;
        },
        deleteBannerSuccess: (state, action: PayloadAction<IBannerDeleteSucess>) => {
            state.loading = false;
            state.bannerList = state.bannerList.filter(i => i._id !== action.payload.id);
            state.bannerOriginList = state.bannerList;
        },
        deleteBannerFailure: (state, action: PayloadAction<IError>) => {
            state.loading = false;
        },

        searchBanner: (state, action: PayloadAction<string>) => {
            state.bannerList = state.bannerOriginList.filter(item => item.gradeId.includes(action.payload));
        },

        showBannerAdd: (state) => {
            state.isShowAdd = true;
        },
        showBannerUpdate: (state, action: PayloadAction<IBannerUpdate>) => {
            state.isShowEdit = true;
            state.bannerUpdate = action.payload;
        },
        hideBannerAdd: (state, action: PayloadAction<null>) => {
            state.isShowAdd = false;
        },
        hideBannerUpdate: (state, action: PayloadAction<null>) => {
            state.isShowEdit = false;
        }
    },
})

const getBannerUpdate = (bannerList: IBanner[], data: IBanner) => {
    const index = bannerList.findIndex(item => item._id === data._id);
    bannerList[index] = data;
    return bannerList;
}

export const {
    getBanners, getBannersSuccess, getBannersFailure,
    createBanner, createBannerSuccess, createBannerFailure,
    updateBanner, updateBannerSuccess, updateBannerFailure,
    deleteBanner, deleteBannerSuccess, deleteBannerFailure, searchBanner,
    showBannerAdd, showBannerUpdate, hideBannerAdd, hideBannerUpdate
} = bannerSlice.actions

export default bannerSlice.reducer